<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ `${user.personalInfo.name} ${user.personalInfo.surname}` }}
      </p>
      <button type="button" class="delete" @click="$parent.close()" />
    </header>

    <section class="modal-card-body">
      <p v-if="user.personalInfo.personalId">
        <b>CPF: </b> {{ user.personalInfo.personalId }}
      </p>

      <p v-if="user.personalInfo.email">
        <b>Email: </b> {{ user.personalInfo.email }}
      </p>

      <p v-if="user.personalInfo.cellphone">
        <b>Celular: </b> {{ user.personalInfo.cellphone }}
      </p>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Fechar
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  props: ["user"]
};
</script>
